// extracted by mini-css-extract-plugin
export default {"title":"MonthlyLeaderboard_title__uG+KS","img":"MonthlyLeaderboard_img__yXDSa"};